{
  "processorType": [
    {
      "id": 0,
      "value": "Choose ...",
      "label": "Choose ...",
      "external": false
    },
    {
      "id": 1,
      "value": "AUTHORIZE_DOT_NET",
      "label": "Authorize.net",
      "external": false
    },
    {
      "id": 2,
      "value": "ELAVON_VIRTUAL_MERCHANT",
      "label": "Elavon Virtual Merchant",
      "external": false
    },
    {
      "id": 3,
      "value": "VANTIV",
      "label": "Vantiv",
      "external": false
    },
    {
      "id": 4,
      "value": "OFFICIAL_PAYMENTS",
      "label": "Official Payments",
      "external": false
    },
    {
      "id": 5,
      "value": "CASHNET",
      "label": "CASHNet",
      "external": false
    },
    {
      "id": 6,
      "value": "TOUCHNET",
      "label": "TouchNet",
      "external": false
    },
    {
      "id": 7,
      "value": "DUMMY",
      "label": "Dummy- For Testing purposes",
      "external": false
    },
    {
      "id": 8,
      "value": "TRANSACT_PAYMENTS",
      "label": "Transact Payments",
      "external": true
    }
  ],
  "creditCardsTypes": [
    {
      "id": 0,
      "value": "Choose ...",
      "label": "Choose ..."
    },
    {
      "id": 1,
      "value": "VISA",
      "label": "Visa"
    },
    {
      "id": 2,
      "value": "MC",
      "label": "Master Card"
    },
    {
      "id": 3,
      "value": "DISC",
      "label": "Discover"
    },
    {
      "id": 4,
      "value": "AMEX",
      "label": "American Express"
    },
    {
      "id": 5,
      "value": "JCB",
      "label": "JCB"
    },
    {
      "id": 6,
      "value": "DINERS_CLUB",
      "label": "Diners Club/Carte Blanche"
    }
  ],
  "AUTHORIZE_DOT_NET": [
    {
      "id": 1,
      "optionName": "login",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "transactionKey",
      "optionValue": ""
    }
  ],
  "VANTIV": [
    {
      "id": 1,
      "optionName": "AccountID",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "ApplicationID",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "url",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "AcceptorID",
      "optionValue": ""
    },
    {
      "id": 5,
      "optionName": "AccountToken",
      "optionValue": ""
    }
  ],
  "ELAVON_VIRTUAL_MERCHANT": [
    {
      "id": 1,
      "optionName": "post_url",
      "optionValue": "https://www.myvirtual"
    },
    {
      "id": 2,
      "optionName": "ssl_pin",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "ssl_merchant_id",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "ssl_test_mode",
      "optionValue": "false"
    },
    {
      "id": 5,
      "optionName": "ssl_user_id",
      "optionValue": ""
    }
  ],
  "OFFICIAL_PAYMENTS": [
    {
      "id": 1,
      "optionName": "userPostalCode",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "userFirstName",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "userCity",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "userEmail",
      "optionValue": ""
    },
    {
      "id": 5,
      "optionName": "endpoint",
      "optionValue": "https://www.officialpayments.com/srv/stp"
    },
    {
      "id": 6,
      "optionName": "clientId",
      "optionValue": ""
    },
    {
      "id": 7,
      "optionName": "productId",
      "optionValue": ""
    },
    {
      "id": 8,
      "optionName": "userAddress",
      "optionValue": ""
    },
    {
      "id": 9,
      "optionName": "userState",
      "optionValue": ""
    },
    {
      "id": 10,
      "optionName": "userCountry",
      "optionValue": ""
    },
    {
      "id": 11,
      "optionName": "cdeSourceCode",
      "optionValue": ""
    },
    {
      "id": 12,
      "optionName": "userPhone",
      "optionValue": ""
    },
    {
      "id": 13,
      "optionName": "userLastName",
      "optionValue": ""
    }
  ],
  "CASHNET": [
    {
      "id": 1,
      "optionName": "customer_code",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "operator_id",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "gateway_url",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "merchant_id",
      "optionValue": ""
    },
    {
      "id": 5,
      "optionName": "password",
      "optionValue": ""
    },
    {
      "id": 6,
      "optionName": "station_user_id",
      "optionValue": ""
    }
  ],
  "TOUCHNET": [
    {
      "id": 1,
      "optionName": "merchant_id",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "password",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "user",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "url",
      "optionValue": ""
    }
  ],
  "DUMMY": [
    {
      "id": 1,
      "optionName": "Dummy",
      "optionValue": ""
    }
  ],
  "TRANSACT_PAYMENTS": [
    {
      "id": 1,
      "optionName": "store_url",
      "optionValue": ""
    },
    {
      "id": 2,
      "optionName": "citation_code",
      "optionValue": ""
    },
    {
      "id": 3,
      "optionName": "permit_code",
      "optionValue": ""
    },
    {
      "id": 4,
      "optionName": "account_parameter",
      "optionValue": ""
    },
    {
      "id": 5,
      "optionName": "full_name_parameter",
      "optionValue": ""
    }
  ]
}
